import { Outlet } from "react-router-dom";
import AuthMiddleware from "../../core/data/middleware/authMiddleware";

const ProtectedLayout = () => {
  return (
    <AuthMiddleware>
      <Outlet />
    </AuthMiddleware>
  );
};

export default ProtectedLayout;

// For superadmin-only routes
export const SuperAdminLayout = () => (
  <AuthMiddleware allowedRoles={["superadmin"]}>
    <Outlet />
  </AuthMiddleware>
);

// For centeradmin-only routes
export const CenterAdminLayout = () => (
  <AuthMiddleware allowedRoles={["centeradmin"]}>
    <Outlet />
  </AuthMiddleware>
);

// For routes accessible by both superadmin and centeradmin
export const SharedAdminLayout = () => (
  <AuthMiddleware allowedRoles={["superadmin", "centeradmin"]}>
    <Outlet />
  </AuthMiddleware>
);
